// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-catalogs-RecordsPage-RecordsPage-module__box--Ei2TM {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__tools--EquxL {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__toolsTop--y8d5Z {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 8px;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__tableBox--i2izd {
  flex: 1;
  overflow: hidden;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__settingsLink--SOela {
  white-space: nowrap;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__filtersBox--FXUy1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.src-pages-catalogs-RecordsPage-RecordsPage-module__filtersLabel--dmqkZ {
  color: rgba(0, 0, 0, 0.55);
}
/*# sourceMappingURL=RecordsPage.module.css.map */`, "",{"version":3,"sources":["webpack://./RecordsPage.module.less","webpack://./src/pages/catalogs/RecordsPage/RecordsPage.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;ACCF;ADEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ACAF;ADGA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;ACDF;ADIA;EACE,OAAA;EACA,gBAAA;ACFF;ADKA;EACE,mBAAA;ACHF;ADMA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;ACJF;ADOA;EACE,0BAAA;ACLF;AACA,iDAAiD","sourcesContent":[".box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n\n.toolsTop {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 8px;\n}\n\n.tableBox {\n  flex: 1;\n  overflow: hidden;\n}\n\n.settingsLink {\n  white-space: nowrap;\n}\n\n.filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n}\n",".box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n.toolsTop {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 8px;\n}\n.tableBox {\n  flex: 1;\n  overflow: hidden;\n}\n.settingsLink {\n  white-space: nowrap;\n}\n.filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n}\n/*# sourceMappingURL=RecordsPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-pages-catalogs-RecordsPage-RecordsPage-module__box--Ei2TM`;
export var tools = `src-pages-catalogs-RecordsPage-RecordsPage-module__tools--EquxL`;
export var toolsTop = `src-pages-catalogs-RecordsPage-RecordsPage-module__toolsTop--y8d5Z`;
export var tableBox = `src-pages-catalogs-RecordsPage-RecordsPage-module__tableBox--i2izd`;
export var settingsLink = `src-pages-catalogs-RecordsPage-RecordsPage-module__settingsLink--SOela`;
export var filtersBox = `src-pages-catalogs-RecordsPage-RecordsPage-module__filtersBox--FXUy1`;
export var filtersLabel = `src-pages-catalogs-RecordsPage-RecordsPage-module__filtersLabel--dmqkZ`;
export default ___CSS_LOADER_EXPORT___;
